import { apiClient } from "./apiClient";

export interface HistoricoPuloSemBordaItem {
  id: number;
  displayId: number;
  orderId: number;
  bordaNome: string;
  itemLabel: string;
  tamanho: string | null;
  usuarioNome: string;
  usuarioId: number;
  horario: string;
  canalOrigem: string;
  tipoFila: string;
  lojaId: number;
  lojaNome: string | null;
}

export interface HistoricoPuloSemBordaResponse {
  itens: HistoricoPuloSemBordaItem[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export async function fetchHistoricoPuloSemBorda(params: {
  data: string;
  lojaId?: number | null;
  page?: number;
  limit?: number;
}): Promise<HistoricoPuloSemBordaResponse> {
  const qs = new URLSearchParams();
  qs.set("data", params.data);
  if (params.lojaId != null && params.lojaId > 0) {
    qs.set("lojaId", String(params.lojaId));
  }
  if (params.page != null) qs.set("page", String(params.page));
  if (params.limit != null) qs.set("limit", String(params.limit));
  return apiClient.get(`/historico-pulo-borda?${qs.toString()}`);
}
